import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema } from "./schema";
import LibBoolean from "../../../../util/libBool";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		setError,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: {
			id_tipoproduto: 0,
			nome: "",
			ordem: 0,
			ativo: true,
			obs: "",
		},
	});

	const [loading, setLoading] = useState(false);
	// const [id_forma, setid_forma] = useState(0);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	const handleChangeInt = (e) => {
		try {
			let value = e.target.value.trim();
			if (value === "") {
				value = 0;
			} else {
				value = parseInt(e.target.value, 10);
			}
			setValue(e.target.name, value);
		} catch {
			setValue(e.target.name, 0);
		}
	};

	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;

				const newData = await processNewData(data);

				Object.keys(newData).forEach((field) => {
					setValue(field, newData[field]);
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	const processNewData = async (data) => {
		return {
			...data,
			ativo: LibBoolean.strToBoolean(data.ativo),
		};
	};

	//#endregion

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			let response;
			const oldID = data[idTable];

			const newData = await ValidateSubmit(data);

			response = await insert(newData);

			const returnUpdated = getReturnUpdated(response);

			const currentId = returnUpdated[idTable];

			await reloadData(oldID, currentId);
			// // Sucesso
			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
			reset();
			handleCloseModalRegister();
		} catch (error) {
			if (error.field && error.field !== "ID_FORMA") {
				// errosAfterPost(error.field, error.message);
			} else
				Notification.showToast({
					message: error.message,
					type: "error",
				});
		}
	};

	const ValidateSubmit = async (data) => {
		const newAtivo = LibBoolean.booleanToStr(data.ativo);

		const newData = {
			...data,
			ativo: newAtivo,
		};

		return newData;
	};

	//#endregion
	return {
		//hooks
		handleOnSubmit,
		handleCloseModalRegister,
		handleChangeInt,

		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,
		loading,

		//formState
		errors,
		isSubmitting,
	};
};
